module.exports = __webpack_public_path__ + "start-left.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/start-left.png
// module id = 302
// module chunks = 0